<template>
  <div class="order-list-page">
    <div class="page-header">
      <span class="page-title">居家养老上门护理服务</span>
    </div>

    <div class="info-card mt20">
      <div class="info-card-head">
        <span class="info-card-title">筛选查询</span>
      </div>
      <el-form :inline="true" ref="search" :model="search" class="mt15">
        <el-form-item prop="patient_keyword">
          <el-input v-model="search.patient_keyword" clearable placeholder="患者姓名/手机号" />
        </el-form-item>
        <el-form-item prop="createRange">
          <el-date-picker
            v-model="search.createRange"
            type="daterange"
            unlink-panels
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="订单创建开始时间"
            end-placeholder="订单创建结束时间"
          />
        </el-form-item>
        <el-form-item prop="serveRange">
          <el-date-picker
            v-model="search.serveRange"
            type="daterange"
            unlink-panels
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="服务记录开始时间"
            end-placeholder="服务记录结束时间"
          />
        </el-form-item>
        <el-form-item prop="order_status">
          <el-select v-model="search.order_status" clearable placeholder="订单状态">
            <el-option label="全部" value="" />
            <el-option v-for="o in OrdersSnStatus" :key="String(o.val)" :label="o.label" :value="o.val" />
          </el-select>
        </el-form-item>
        <el-form-item prop="caregiver_keyword">
          <el-input v-model="search.caregiver_keyword" clearable placeholder="护工姓名/手机号" />
        </el-form-item>
        <el-form-item prop="disability">
          <el-select v-model="search.disability" clearable placeholder="失能/半失能">
            <el-option v-for="d in OrdersSnDisabilityFilter" :key="String(d.val)" :label="d.label" :value="d.val" />
          </el-select>
        </el-form-item>
        <el-form-item prop="station_ids">
          <el-select
            v-model="search.station_ids"
            multiple
            collapse-tags
            filterable
            clearable
            placeholder="护理站（可多选）"
          >
            <el-option v-for="s in stations" :key="s.id" :label="s.title" :value="s.id" />
          </el-select>
        </el-form-item>
        <el-form-item prop="address">
          <el-input v-model="search.address" clearable placeholder="地址" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="searchData">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetForm">重置</el-button>
          <el-button v-if="disRoleArr.includes('1')" type="success" icon="el-icon-upload2" @click="createVisible = true">导入订单</el-button>
          <el-button icon="el-icon-download" @click="handleExport">导出数据</el-button>
          <el-button
            v-if="canBatchAllocate"
            :disabled="!selectedAssignRows.length"
            @click="openBatchAssignDialog('assign')"
          >批量指派</el-button>
          <el-button
            v-if="canBatchAllocate"
            :disabled="!selectedReassignRows.length"
            @click="openBatchAssignDialog('reassign')"
          >批量改派</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="info-card mt20">
      <div class="info-card-head">
        <span class="info-card-title">订单列表</span>
        <div class="summary-line">
          <span>订单共 <em>{{ summaryOrderCount }}</em> 条</span>
          <span class="summary-gap">服务次数 <em>{{ summaryServiceTimes }}</em> 次</span>
          <span class="summary-gap">服务总金额 <em>{{ totalAmount }}</em> 元</span>
        </div>
      </div>
      <el-table
        ref="ordersTable"
        v-loading="tableLoading"
        :data="tableData"
        stripe
        max-height="600"
        :row-class-name="getTableRowClassName"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.6)"
        :header-cell-style="{ background: '#fafafa', color: '#303133' }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          v-if="canBatchAllocate"
          type="selection"
          :selectable="isRowSelectable"
          width="55"
          align="center"
        />
        <el-table-column prop="order_no" label="订单编号" min-width="168" show-overflow-tooltip />
        <el-table-column label="患者" min-width="158">
          <template slot-scope="{ row }">
            <div class="person-cell">
              <div class="person-name">{{ row.user_name || row.name || '—' }}</div>
              <div class="person-tel">{{ row.user_tel || row.tel || '—' }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" minWidth="120" align="center">
          <template slot-scope="scope">
            <el-select
              v-if="disRoleArr.includes('2') && (scope.row.order_status !== 10 && scope.row.order_status !== 20)"
              v-model="scope.row.order_status"
              placeholder="订单状态"
              size="small"
              style="width: 110px"
              @change="changeStatus(scope.row.id, $event)"
            >
              <el-option label="服务中" :value="30"></el-option>
              <el-option label="已完成" :value="60"></el-option>
            </el-select>
            <el-tag v-else size="mini" :type="statusTagType(scope.row.order_status)" effect="plain">{{ scope.row.order_status | ordersSnStatusFilter }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="地址" min-width="180" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span v-if="row.address">{{ row.address }}</span>
            <span v-else class="empty-text">—</span>
          </template>
        </el-table-column>
        <el-table-column label="身份证号" min-width="170" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span v-if="row.id_card">{{ row.id_card }}</span>
            <span v-else class="empty-text">—</span>
          </template>
        </el-table-column>
        <el-table-column label="最后一次服务时间" min-width="200">
          <template slot-scope="{ row }">
            <span v-if="row.last_log_time">{{ formatCreated(row.last_log_time) }}</span>
            <span v-else class="empty-text">—</span>
          </template>
        </el-table-column>
        <el-table-column label="下单时间" min-width="180">
          <template slot-scope="{ row }">
            <span v-if="row.created_at">{{ formatCreated(row.created_at) }}</span>
            <span v-else class="empty-text">—</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="150" align="center">
          <template slot-scope="scope">
            <el-link type="primary" icon="el-icon-tickets" @click="goDetail(scope.row.id)" class="op-link">详情</el-link>
            <el-link v-if="showDeleteOrder" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row.id)" class="op-link">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <CreateOrderDialog :visible.sync="createVisible" @success="getList" />
      <el-dialog
        :title="assignMode === 'reassign' ? '批量改派护工' : '批量指派护工'"
        :visible.sync="assignVisible"
        width="600px"
        center
        destroy-on-close
        :close-on-click-modal="false"
      >
        <el-form :model="assignForm" label-width="153px">
          <el-form-item label="护工">
            <el-select
              v-model="assignForm.nurse_id"
              allow-create
              filterable
              default-first-option
              clearable
              placeholder="请选择护工"
              class="w100"
            >
              <el-option
                v-for="n in nurseCandidates"
                :key="n.id"
                :label="`${n.name}/${n.tel}`"
                :value="n.id"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="assignVisible = false">取 消</el-button>
          <el-button type="primary" :loading="assignLoading" @click="submitBatchAssign">确 定</el-button>
        </div>
      </el-dialog>
      <div class="block">
        <el-pagination
          background
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page_size"
          :current-page="page_number"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  batchAllocateOrderInfo,
  delOrderById,
  exportOrdersSn,
  fetchNurseList,
  fetchOrdersSnList,
  fetchStationList, switchStatusLeave
} from '@/api'
import { OrdersSnDisabilityFilter, OrdersSnStatus } from '@/enum/orders'
import { filterEnum } from '@/utils/filter'
import { formatDate } from 'element-ui/lib/utils/date-util'
import { getSnChildRoleIds, isAdmin } from '@/utils/util'
import { confirmDeleteOrder } from '@/utils/confirm-delete'
import CreateOrderDialog from './components/CreateOrderDialog.vue'

export default {
  name: 'OrdersSn',
  components: { CreateOrderDialog },
  filters: {
    ordersSnStatusFilter(val) {
      if (val === '' || val == null) return '-'
      return filterEnum(val, OrdersSnStatus).label || filterEnum(Number(val), OrdersSnStatus).label || '-'
    }
  },
  data() {
    return {
      OrdersSnDisabilityFilter,
      OrdersSnStatus,
      createVisible: false,
      assignVisible: false,
      assignLoading: false,
      assignMode: 'assign',
      tableLoading: false,
      page_size: 10,
      page_number: 1,
      total: 0,
      summaryOrderCount: 0,
      summaryServiceTimes: 0,
      totalAmount: 0,
      stations: [],
      nurseCandidates: [],
      selectedRows: [],
      assignForm: {
        nurse_id: ''
      },
      search: {
        patient_keyword: '',
        createRange: [],
        serveRange: [],
        order_status: '',
        caregiver_keyword: '',
        disability: '',
        address: '',
        station_ids: []
      },
      tableData: []
    }
  },
  computed: {
    disRoleArr() {
      return getSnChildRoleIds(this.$store.state.rules)
    },
    showDeleteOrder() {
      return isAdmin() || this.disRoleArr.includes('3')
    },
    /** 批量指派/改派：失能二级权限 8 */
    canBatchAllocate() {
      return isAdmin() || this.disRoleArr.includes('8')
    },
    selectedAssignRows() {
      return (this.selectedRows || []).filter(row => this.isUnassignedRow(row))
    },
    selectedReassignRows() {
      return (this.selectedRows || []).filter(row => !this.isUnassignedRow(row))
    }
  },
  mounted() {
    this.loadStations()
    this.getList()
  },
  methods: {
    formatDate,
    isUnassignedRow(row) {
      return Number(row && row.is_allocated) === 0
    },
    isRowSelectable(row) {
      return Number(row.order_status) !== 60
    },
    getTableRowClassName({ row }) {
      return this.isRowSelectable(row) ? '' : 'selection-hidden-row'
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection
    },
    statusTagType(status) {
      const map = { 1: 'warning', 10: 'info', 20: 'info', 30: 'primary', 60: 'success', 50: 'danger', 41: 'danger', 40: 'warning', 2: 'info' }
      return map[status] || 'info'
    },
    loadStations() {
      fetchStationList({ pageSize: 500, pageNumber: 1, title: '', area: '', status: '' }).then(res => {
        if (res.status && res.data && res.data.list) {
          this.stations = res.data.list
        }
      })
    },
    async getNurseList() {
      const { status, data } = await fetchNurseList()
      if (status && data != null) {
        this.nurseCandidates = Array.isArray(data) ? data : data.list || []
      } else {
        this.nurseCandidates = []
      }
    },
    async openBatchAssignDialog(mode) {
      const isReassign = mode === 'reassign'
      const rows = isReassign ? this.selectedReassignRows : this.selectedAssignRows
      if (!rows.length) {
        this.$message.warning(isReassign ? '请先选择需要改派的订单' : '请先选择需要指派的订单')
        return
      }
      this.assignMode = isReassign ? 'reassign' : 'assign'
      await this.getNurseList()
      this.assignForm = { nurse_id: '' }
      this.assignVisible = true
    },
    clearTableSelection() {
      this.selectedRows = []
      this.$nextTick(() => {
        if (this.$refs.ordersTable) {
          this.$refs.ordersTable.clearSelection()
        }
      })
    },
    changeStatus(id, status) {
      const params = { order_id: id, status }
      switchStatusLeave(params).then(res => {
        if (res.status) {
          this.$message.success(res.msg)
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    formatCreated(v) {
      if (v == null || v === '') return '-'
      if (typeof v === 'number') return formatDate(v * (v < 1e12 ? 1000 : 1), 'yyyy-MM-dd HH:mm:ss')
      return String(v)
    },
    /**
     * 列表 / 导出 请求体，与 Apifox 约定一致（经 request 拦截器写入 body，head.token 自动带上）
     * order_status: 与 OrdersSnStatus 一致，1 待服务 2 服务中 3 已结束；空为全部
     * disabled_type: 1 失能，2 半失能；不传或空为全部
     * region: 护理站，空字符串为全部；多选为 id 逗号拼接
     * frist_log_time: 订单创建时间范围，字符串 start,end（yyyy-MM-dd,yyyy-MM-dd）
     * last_log_time: 服务记录时间范围，字符串 start,end（yyyy-MM-dd,yyyy-MM-dd）
     */
    buildListRequestBody() {
      const { page_size, page_number, search } = this
      const body = {
        pageSize: String(page_size),
        pageNumber: String(page_number),
        user_name_or_tel: (search.patient_keyword || '').trim(),
        address: (search.address || '').trim(),
        nurse_name_or_tel: (search.caregiver_keyword || '').trim(),
        order_status:
          search.order_status === '' || search.order_status == null
            ? ''
            : String(Number(search.order_status)),
        disabled_type:
          search.disability === '' || search.disability == null ? '' : String(search.disability),
        region:
          Array.isArray(search.station_ids) && search.station_ids.length
            ? search.station_ids.join(',')
            : ''
      }
      if (search.createRange && search.createRange.length === 2) {
        body.frist_log_time = `${search.createRange[0]},${search.createRange[1]}`
      }
      if (search.serveRange && search.serveRange.length === 2) {
        body.last_log_time = `${search.serveRange[0]},${search.serveRange[1]}`
      }
      return body
    },
    getList() {
      this.tableLoading = true
      fetchOrdersSnList(this.buildListRequestBody())
        .then(res => {
          if (res.status && res.data) {
            this.tableData = res.data.list || []
            this.total = res.data.total != null ? res.data.total : 0
            this.summaryOrderCount = res.data.order_count != null ? res.data.order_count : this.total
            this.summaryServiceTimes = res.data.served_num != null ? Number(res.data.served_num) : 0
            this.totalAmount = res.data.month_served_total != null ? Number(res.data.month_served_total) : 0
          } else {
            this.tableData = []
            this.total = 0
            this.summaryOrderCount = 0
            this.summaryServiceTimes = 0
            this.totalAmount = 0
          }
          this.clearTableSelection()
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    searchData() {
      this.page_number = 1
      this.getList()
    },
    resetForm() {
      this.$refs.search.resetFields()
      this.search.station_ids = []
      this.page_number = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.page_size = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.page_number = val
      this.getList()
    },
    handleExport() {
      const params = this.buildListRequestBody()
      exportOrdersSn(params).then(res => {
        if (res.data) {
          const elink = document.createElement('a')
          elink.href = res.data
          elink.download = '数据表格.xlsx'
          document.body.appendChild(elink)
          elink.click()
          document.body.removeChild(elink)
        } else {
          this.$message.warning(res.msg || '没有数据可以导出')
        }
      })
    },
    submitBatchAssign() {
      if (!this.assignForm.nurse_id) {
        this.$message.warning('请选择护工')
        return
      }
      const isReassign = this.assignMode === 'reassign'
      const rows = isReassign ? this.selectedReassignRows : this.selectedAssignRows
      const orderIds = rows.map(item => item.id).filter(id => id !== '' && id != null)
      if (!orderIds.length) {
        this.$message.warning(isReassign ? '请先选择需要改派的订单' : '请先选择需要指派的订单')
        return
      }
      this.assignLoading = true
      batchAllocateOrderInfo({
        nurse_id: this.assignForm.nurse_id,
        order_ids: orderIds.join(',')
      })
        .then(res => {
          if (res.status) {
            this.$message.success(res.msg || (isReassign ? '批量改派成功' : '批量指派成功'))
            this.assignVisible = false
            this.getList()
          } else {
            this.$message.warning(res.msg || (isReassign ? '批量改派失败' : '批量指派失败'))
          }
        })
        .finally(() => {
          this.assignLoading = false
        })
    },
    goDetail(id) {
      this.$router.push({ path: '/orders_sn_detail', query: { id: String(id) } })
    },
    handleDelete(order_id) {
      confirmDeleteOrder(this, '确定删除吗?')
        .then(() => {
          delOrderById({ order_id }).then(res => {
            if (res.status) {
              this.$message({
                type: 'success',
                message: res.msg || '删除成功!'
              })
              this.getList()
            } else {
              this.$message({
                type: 'warning',
                message: res.msg
              })
            }
          })
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.order-list-page {
  padding: 16px 20px 30px;
}
.page-header {
  padding-bottom: 14px;
  border-bottom: 1px solid #ececec;
}
.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}
.mt20 { margin-top: 20px; }
.mt15 { margin-top: 15px; }
.info-card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 16px 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
}
.info-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid #f2f6fc;
}
.info-card-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  position: relative;
  padding-left: 10px;
}
.info-card-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 14px;
  background: #26a4b2;
  border-radius: 2px;
}
.person-cell { line-height: 1.6; }
.person-name { color: #303133; font-weight: 500; }
.person-tel { color: #909399; font-size: 13px; }
.address-cell { color: #606266; line-height: 1.6; }
.empty-text { color: #c0c4cc; }
.op-link { margin-right: 12px; }
.w100 { width: 100%; }
::v-deep .selection-hidden-row .el-checkbox {
  display: none;
}
.block {
  text-align: center;
  margin-top: 20px;
}
.summary-line {
  font-size: 13px;
  color: #606266;
  em {
    font-style: normal;
    color: #26a4b2;
    font-weight: 600;
  }
  .summary-gap {
    margin-left: 24px;
  }
}
</style>
